import { render, staticRenderFns } from "./confirmLoan.vue?vue&type=template&id=3a3967e3&scoped=true"
import script from "./confirmLoan.vue?vue&type=script&lang=js"
export * from "./confirmLoan.vue?vue&type=script&lang=js"
import style0 from "./confirmLoan.vue?vue&type=style&index=0&id=3a3967e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3967e3",
  null
  
)

export default component.exports